import { Input, Component } from "@angular/core";
import { IItemDetail } from "../../../interfaces/iconfigurationset";

@Component({
    selector: "country-comparison-item",
    templateUrl: "./countrycomparisonitem.component.html",
    standalone: false
})
export class CountryComparisonItemComponent {

    @Input() primaryCountry: any;
    @Input() secondaryCountry: any;
    @Input() tertiaryCountry: any;
    @Input() depth!: number;

    sectionHidden = false;

    public toggleSection(): void {
        this.sectionHidden = !this.sectionHidden;
    }

    getSecondaryCountryItemValue(id: number): string {
        return this.getItemDetailValue(this.secondaryCountry, id);
    }

    getTertiaryCountryItemValue(id: number): string {
        return this.getItemDetailValue(this.tertiaryCountry, id);
    }

    getItemDetailValue(itemDetails: IItemDetail[], id: number): string {
        if (!itemDetails) {
            return "";
        }

        var filteredList: IItemDetail[] = itemDetails.filter((i: IItemDetail) => {
            return i.itemConfigId === id;
        });

        if (!filteredList || filteredList.length === 0) {
            return "";
        }

        return filteredList[0].value;
    }
}